import Constants from "expo-constants";
import { isWeb } from "./platform";

const isExpoGoRuntime = () => {
	const isExpoGo =
		Constants.executionEnvironment === "storeClient" ||
		Constants.appOwnership === "expo";
	return isExpoGo;
};

export const isNativeModulesDisabled = (): boolean =>
	isWeb || isExpoGoRuntime();

export const isNativeStorageDisabled = (): boolean => isNativeModulesDisabled();
